import React, { useRef } from "react";
import { CloseGlyph, MinimizeGlyph, ZoomGlyph } from "./icons";

// Ignore a repeat click while the window is still animating from the last one,
// so a double-click on zoom doesn't zoom and immediately unzoom.
const SETTLE_MS = 450;

// The close, minimize and zoom buttons. Like AppKit's, each button's clickable area is larger
// than its dot and the areas meet, so there are no dead gaps between them. Glyphs appear while
// the pointer is over the group; in a background window the dots are gray until then.
const TrafficLights = ({ onClose, onMinimize, onZoom, onPrepare, zoomed }) => {
  const last = useRef(0);
  const guard = (fn) => () => {
    const now = Date.now();
    if (now - last.current < SETTLE_MS) return;
    last.current = now;
    fn();
  };

  return (
    // Pointing at the controls is the moment to get a minimize animation ready.
    <div
      className="traffic-lights"
      role="group"
      aria-label="Window controls"
      onPointerEnter={onPrepare}
      onFocus={onPrepare}
    >
      <button type="button" className="traffic-btn traffic-close" onClick={guard(onClose)} aria-label="Close">
        <span className="traffic-dot">
          <CloseGlyph />
        </span>
      </button>
      <button type="button" className="traffic-btn traffic-min" onClick={guard(onMinimize)} aria-label="Minimize">
        <span className="traffic-dot">
          <MinimizeGlyph />
        </span>
      </button>
      <button
        type="button"
        className="traffic-btn traffic-zoom"
        onClick={guard(onZoom)}
        aria-label={zoomed ? "Exit full size" : "Zoom"}
      >
        <span className="traffic-dot">
          <ZoomGlyph />
        </span>
      </button>
    </div>
  );
};

export default TrafficLights;
